<mat-card [ngClass]="'mat-' + color + '-total-card'">
  <mat-card-header>
    <mat-card-title>{{title}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <span class="count">{{count}}</span>
  </mat-card-content>
</mat-card>
